import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import styles from './App.module.scss';

import languages from "./Assets/Language/Langloader";
import LocaleHandler from "./LocaleHandler";
import Loanform from './components/Pages/Loanform/Loanform';
import Success from './components/Pages/Loanform/Success/Success';
import { I18n } from 'react-polyglot';
import ErrorBoundary from './ErrorBoundary';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Fileupload from './components/Pages/Fileupload/Fileupload';


function App() {
    let localeTemp = "no";
    if (localStorage.getItem("language") != null) {
        localeTemp = localStorage.getItem("language")?.toLowerCase() ?? "no";
    }
    let languageTemp: any = {};
    languageTemp = languages(localeTemp);

    const [locale, setLocale] = React.useState(localeTemp);
    const [messages, setMessages] = React.useState(languageTemp);

    useEffect(() => {
        setMessages(languages(locale));
    }, [locale]);
    
    return (
        <ErrorBoundary>
            <LocaleHandler.Provider value={{locale, setLocale}}>
                <I18n locale={locale} messages={messages}>
                    <>
                        <ToastContainer
                            position="bottom-right"
                            autoClose={7000}
                            icon={({theme, type}) => {
                                if (type === toast.TYPE.DEFAULT) return <span className="material-symbols-outlined">pending</span>;
                                if (type === toast.TYPE.INFO) return <span className="material-symbols-outlined">lightbulb_circle</span>;
                                if (type === toast.TYPE.SUCCESS) return <span className="material-symbols-outlined">check_circle</span>;
                                if (type === toast.TYPE.ERROR) return <span className="material-symbols-outlined">error</span>;
                            }}
                            className={styles.toast}
                        />
                        <Router>
                            <div className={styles.maincontent}>
                                <Routes>
                                    <Route path="/" element={<Navigate replace to="/loanform" />} />
                                    <Route path="/loanform/:formid" element={ <Loanform /> }/>
                                    <Route path="/loanform/:formid/success" element={ <Success /> }/>
                                    <Route path="/filopplasting/:formid" element={ <Fileupload /> }/>
                                </Routes>
                            </div>
                        </Router>
                    </>
                </I18n>
            </LocaleHandler.Provider>
        </ErrorBoundary>
    );
}

export default App;